<div class="wrapper wrapper-content" *ngIf="isLoaded()">
  <div class="container-fluid ">
    <div class="row">
      <div class="col-12">
        <div>
          <ul style="list-style-type: none;" class="ulClass">
            <ng-container *ngFor="let option of helperOptions">
              <li class="liClass">
                <div class="shadow-hover hover-bg-white hide-child">
                  <div class="liDivIcon">
                    <a (click)="openUrl(option.url)" class="no-underline hover-bg-blue4 hover-white">
                      <span *ngIf="isQuestion(option.helpType)" style="color: #007ad9;"><i class="fas fa-question"
                          style="font-size: 48px;"></i></span>
                      <span *ngIf="isError(option.helpType)" style="color: #007ad9;"><i class="fas fa-meteor"
                          style="font-size: 48px;"></i></span>
                      <span *ngIf="isImprovement(option.helpType)" style="color: #007ad9;"><i
                          class="far fa-comment-dots" style="font-size: 48px;"></i></span>
                      <span *ngIf="isList(option.helpType)" style="color: #007ad9;"><i class="far fa-list-alt"
                          style="font-size: 48px;"></i></span>
                    </a>
                  </div>
                  <div class="liDivText">
                    <span class="db select-all gray5 hover-gray7 text">{{option.name | translate}}</span>
                  </div>
                </div>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="helpContent; else noHelp">
      <div class="col-3 pl-0 sticky-top help-index">
        <div class="sticky-top">
          <p-tree [value]="helpContent" styleClass="pl-0" selectionMode="single" [(selection)]="selectedHelp"
            (onNodeSelect)="resetScroll()"></p-tree>
        </div>
      </div>
      <div class="col-9 m-t-lg" id="print-section">
        <div class="col-12 text-right">
          <button (click)="this.print()" class="btn btn-sm btn-outline-primary print-btn"
            title="{{ 'General.printsection' | translate }}" type="button"><i class="fa fa-print"></i> {{
            'General.printsection' | translate }}</button>
        </div>
        <h1 *ngIf="selectedHelp">{{ selectedHelp.label }}</h1>
        <div class="col-12 pb-4" *ngIf="isIndexNeeded(selectedHelp)">
          <ng-container *ngIf="selectedHelp; else noSelection">
            <ng-container *ngIf="isFolder(selectedHelp)">
              <ng-container
                *ngTemplateOutlet="indexEntry; context: { folder: selectedHelp, folderid: '' , level: 2}"></ng-container>
            </ng-container>
            <ng-container *ngIf="!isFolder(selectedHelp)">
              <div *ngFor="let element of selectedHelp.data.content; let grpid = index">
                <a *ngIf="!isFolder(selectedHelp)" style="font-weight: 200;"
                  [routerLink]="['/generalHelp#'+element.identifier]" (click)="onGotoElement(element.identifier)">{{
                  grpid+1 }}. {{ element.name }}</a>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="col-12">
          <ng-container *ngIf="selectedHelp; else noSelection">
            <ng-container
              *ngTemplateOutlet="helpEntry; context: { folder: selectedHelp, folderid: '' , level: 2}"></ng-container>
          </ng-container>
        </div>
        <ng-template #noSelection>{{ 'Help.noElements' | translate }}</ng-template>
      </div>
      <ng-template #noHelp>{{ 'Help.noHelp' | translate }}</ng-template>
    </div>
  </div>
</div>
<ng-template #indexEntry let-folder="folder" let-folderid="folderid" let-level="level">
  <div *ngFor="let element of folder.children; let grpid = index" [ngClass]="'ml-' + ((level-1)*2)">
    <h2 *ngIf="level === 2" class="mb-2 mt-3" style="font-weight: 200;"><a
        [routerLink]="['/generalHelp#'+ 'IDX_'+(folderid?folderid:'0')+'_'+grpid]"
        (click)="onGotoElement('IDX_'+(folderid?folderid:'0')+'_'+grpid)">{{
        (folderid?folderid+'.':'')+(grpid+1) }}. {{ element.label }} </a></h2>
    <h3 *ngIf="level === 3" class="mb-2 mt-3" style="font-weight: 200;"><a
        [routerLink]="['/generalHelp#'+'IDX_'+(folderid?folderid:'0')+'_'+grpid]"
        (click)="onGotoElement('IDX_'+(folderid?folderid:'0')+'_'+grpid)">{{
        (folderid?folderid+'.':'')+(grpid+1) }}. {{ element.label }} </a></h3>
    <h4 *ngIf="level >= 4" class="mb-2 mt-3" style="font-weight: 200;"><a
        [routerLink]="['/generalHelp#'+'IDX_'+(folderid?folderid:'0')+'_'+grpid]"
        (click)="onGotoElement('IDX_'+(folderid?folderid:'0')+'_'+grpid)">{{
        (folderid?folderid+'.':'')+(grpid+1) }}. {{ element.label }} </a></h4>
    <ng-container *ngIf="hasContent(element) && !isFolder(element)">
      <div *ngFor="let grp of element.data.content; let elemId = index" class="pl-4">
        <a [routerLink]="['/generalHelp#'+grp.identifier]" style="font-weight: 200;"
          (click)="onGotoElement(grp.identifier)">{{
          (folderid?folderid+'.':'')+(grpid+1)
          }}.{{ elemId+1 }} {{ grp.name }}</a>
      </div>
    </ng-container>
    <ng-container *ngIf="isFolder(element)">
      <ng-container
        *ngTemplateOutlet="indexEntry; context: { folder: element, folderid:  (folderid?folderid+'.':'')+(grpid+1) , level: level+1 }"></ng-container>
    </ng-container>
  </div>
</ng-template>
<ng-template #helpEntry let-folder="folder" let-folderid="folderid" let-level="level">
  <div *ngFor="let element of folder.children; let grpid = index" [ngClass]="'ml-' + ((level-1)*2)">
    <h2 *ngIf="level === 2" class="mb-4 mt-3" style="font-weight: 100;"
      id="{{ 'IDX_'+(folderid?folderid:'0')+'_'+grpid }}">{{
      (folderid?folderid+'.':'')+(grpid+1) }}. {{ element.label }}</h2>
    <h3 *ngIf="level === 3" class="mb-4 mt-3" style="font-weight: 100;"
      id="{{ 'IDX_'+(folderid?folderid:'0')+'_'+grpid }}">{{
      (folderid?folderid+'.':'')+(grpid+1) }}. {{ element.label }}</h3>
    <h4 *ngIf="level === 4" class="mb-4 mt-3" style="font-weight: 100;"
      id="{{ 'IDX_'+(folderid?folderid:'0')+'_'+grpid }}">{{
      (folderid?folderid+'.':'')+(grpid+1) }}. {{ element.label }}</h4>
    <ng-container *ngIf="hasContent(element) && !isFolder(element)">
      <div *ngFor="let entry of element.data.content; let elemId = index" [ngClass]="'ml-' + ((level-1)*2)">
        <plyca-helpElement [helpElement]="entry" [showTitle]="true" [indexLevel]="level"
          [indexStr]="''+(folderid?folderid+'.':'')+(grpid+1)+'.'+(elemId+1)">
        </plyca-helpElement>
      </div>
    </ng-container>
    <ng-container *ngIf="isFolder(element)">
      <ng-container
        *ngTemplateOutlet="helpEntry; context: { folder: element, folderid:  (folderid?folderid+'.':'')+(grpid+1) , level: level+1 }"></ng-container>
    </ng-container>
  </div>
  <ng-container *ngIf="!isFolder(folder)">
    <div *ngFor="let entry of folder.data.content; let elemId = index" [ngClass]="'ml-' + ((level-1)*2)">
      <plyca-helpElement [helpElement]="entry" [showTitle]="true" [indexLevel]="level"
        [indexStr]="''+(folderid?folderid+'.':'')+(elemId+1)">
      </plyca-helpElement>
    </div>
  </ng-container>
</ng-template>